import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useAuthGuard } from '@/shared/hooks/useAuthGuard';
import { useUserStore } from '@/shared/stores/useUserStore';

import MyAccount from './components/MyAccount';
import MyPage from './components/MyPage';
import MyPageNav from './components/MyPageNav';
import MyShoppingInfo from './components/MyShoppingInfo';
import ShoppingDetail from './components/ShoppingDetail';

const MyPagePage = () => {
  const { userData, fetchUserData } = useUserStore();
  const params = useParams();
  const urlValue = params['*']; // Keep this line for context

  const { isAuthenticated } = useAuthGuard({
    redirectTo: '/',
    message: 'Please log in to access My Page.',
  });

  useEffect(() => {
    if (isAuthenticated) {
      fetchUserData();
    }
  }, [isAuthenticated, fetchUserData]);

  return (
    <div className="mx-auto mb-[100px] flex min-h-[26.5rem] w-[60.5rem] justify-between pt-[68px]">
      <MyPageNav />
      {userData && (!urlValue || urlValue === '*') && (
        <MyPage userData={userData} />
      )}
      {userData && urlValue === 'account' && <MyAccount userData={userData} />}
      {userData && urlValue === 'shoppinginfo' && <MyShoppingInfo />}
      {userData && urlValue && urlValue.startsWith('shoppingdetail') && (
        <ShoppingDetail uuid={urlValue.split('/')[1] || ''} />
      )}
    </div>
  );
};

export default MyPagePage;
